import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ContractUsage } from "../types";

export const getContractUsageRequest = (
  billingProfileId: string,
  contractId: string
) => {
  return apiProxyRequest<ContractUsage>(
    `/billing/profiles/${encodeURIComponent(billingProfileId)}/contract/${encodeURIComponent(
      contractId
    )}/usage`
  );
};
